import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { RoleManagement } from '@configs/role.config';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { User } from '../app.urls';
import { CollectionService } from './collection.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class RoleManagementService {
  public enableFeature = true;
  public accessData: SelectedUserRole;
  public navigationRole: NavigationRole;
  public redirectToDefaultPage: boolean = false;
  public userRoles: SelectedUserRole[] = [];
  private routeSubscription: Subscription;
  private currentCollectionId: string;
  public tagAccessData: SelectedTagsRole;
  collectionData: any;
  redirectToDefaultHomePage: boolean = true;
  constructor(
    private router: Router,
    private http: HttpClient,
    private userService: UserService,
    private collectionService: CollectionService,
  ) {
    if (!this.enableFeature) {
      this.tagAccessData = { updateAllowed: true, deleteAllowed: true, insertAllowed: true, viewAllowed: true, featureName: RoleManagement.RoleDisabled, rolesAssigned: '' }
      this.accessData = { updateAllowed: true, deleteAllowed: true, insertAllowed: true, viewAllowed: true, featureName: RoleManagement.RoleDisabled, rolesAssigned: '', tagAccessData: this.tagAccessData };
    }
    else {
      if (sessionStorage.currentUser) {
        this.startRoleManagement();
        // this.getCollectionData();
      }
    }

    // this.getCollectionData();
  }

  public startRoleManagement() {
    if (this.enableFeature) {
      this.getAccessBasedOnUrl();
      if (!this.routeSubscription) { this.getAccessBasedOnUrl(); }
    }
  }

  private getAccessBasedOnUrl() {
    this.routeSubscription = this.router.events.pipe(filter(event => event instanceof NavigationStart), map((event: NavigationStart) => event.url))
      .subscribe(url => {
        this.getAccessDetails(this.getFeatureFromUrl(url), this.redirectToDefaultPage)
      }
    )
  }

  public getNavigationEnableDisable() {
    this.userRoles.forEach(role => {
      this.navigationRole = { ...this.navigationRole, [role.featureName]: role.viewAllowed };
    });
  }

  public getAccessDetails(currentFeature: string, redirectToDefaultPage: boolean) {
    // if (this.currentCollectionId !== localStorage.defaultcollectionid) {
      this.currentCollectionId = sessionStorage.defaultcollectionid;
      this.userRoles = [];
      this.tagAccessData = { featureName: currentFeature, viewAllowed: false, deleteAllowed: false, insertAllowed: false, updateAllowed: false, rolesAssigned: '' }
      this.accessData = { featureName: currentFeature, viewAllowed: false, deleteAllowed: false, insertAllowed: false, updateAllowed: false, rolesAssigned: '', tagAccessData: this.tagAccessData };
      Object.values(RoleManagement).forEach(role => this.navigationRole = { ...this.navigationRole, [role]: false });
      if (this.currentCollectionId) {
        this.getUserRole(+this.currentCollectionId).subscribe(data => {
          this.userRoles = data.data.userrole;
          // sessionStorage.currentUser = JSON.stringify({ ...JSON.parse(sessionStorage.currentUser || '{}'), accessToken: data.data.updatedToken });
          if (currentFeature && this.userRoles && this.userRoles.length) {
            this.getNavigationEnableDisable();
            this.accessData = this.userRoles.find(role => role.featureName === currentFeature);
            if (this.accessData?.featureName === "Items" || this.accessData?.featureName === "Tests") {
              this.getPermissionForTags(this.accessData);
            }
          }

          // this.checkForUserAccess();

          if (redirectToDefaultPage) { this.navigateToDefaultPage(); }
        });
      }
      else { console.warn(`Permission not found...!`); }
    // }
    // else {
    //   this.accessData = this.userRoles.find(role => role.featureName === currentFeature);
    // }
  }

  public getPermissionForTags(tagAccess: SelectedTagsRole) {
    const accessDataForTag = this.userRoles.find(role => role.featureName === 'Tags')
    this.accessData = { ...tagAccess, tagAccessData: accessDataForTag }
  }

  public navigateToDefaultPage() {
    const collectionUUID = JSON.parse(sessionStorage.defaultcollectionuuid);
    if (this.redirectToDefaultHomePage) {
      this.router.navigate([`/collections/${collectionUUID}/home`]);
    } else if (this.validateAndNavigate(RoleManagement.Items) || !this.userRoles || !this.userRoles.length) {
      this.router.navigate([`/collections/${collectionUUID}/items`]);
    }
    else if (this.validateAndNavigate(RoleManagement.Tests)) {
      this.router.navigate([`/collections/${collectionUUID}/test`]);
    }
    else if (this.validateAndNavigate(RoleManagement.Tags)) {
      this.router.navigate([`/collections/${collectionUUID}/tags`]);
    }
    else if (this.validateAndNavigate(RoleManagement.Examinees)) {
      this.router.navigate([`/examinees`]);
    }
    else if (this.validateAndNavigate(RoleManagement.Reports)) {
      this.router.navigate([`/collections/${collectionUUID}/reports`]);
    }
    else if (this.validateAndNavigate(RoleManagement.Users)) {
      this.router.navigate([`/collections/${collectionUUID}/users`]);
    }
    this.redirectToDefaultPage = false;
  }

  private validateAndNavigate(featureName: string): boolean {
    this.accessData = this.userRoles.find(role => role.featureName === featureName);
    const role = this.userRoles.find(d => d.featureName === featureName);
    return role && role.viewAllowed;
  }

  public getFeatureFromUrl(navigationLink: string): string {
    const roleFeatures = Object.values(RoleManagement);
    navigationLink = navigationLink.replace(new RegExp("\\b" + 'test' + "\\b"), 'tests').replace('examinee-group', 'Examinees').replace('Assign-privileges', 'roles');
    return roleFeatures.find(role => navigationLink.split('/').reverse().find(nav => role.toLowerCase() === nav.toLowerCase()));
  }

  //API for getUserRole
  public getUserRole(collectionId: number): Observable<any> {
    return this.http.get<any>(User.UserRole + `${collectionId}`);
  }

  getCollectionData(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.collectionService.getCollection()?.subscribe((collectionData: any) => {
        if (collectionData) {
          this.collectionData = collectionData?.data;
          resolve(true);
        }
        resolve(false);
      }, (error: any) => {
        resolve(false);
      });
    });
  }

  getUserRoleByCollectionId(collectionId: number): Promise<any> {
    return new Promise<boolean>((resolve) => {
      this.getUserRole(collectionId).subscribe((data) => {
        if(data) {
          resolve(data.data.userrole);
        }
        resolve(null);
      });
    });
  }

  private async checkForUserAccess() {
    if (!this.collectionData || this.collectionData.length == 0) {
      await this.getCollectionData();
    }

    let routeSegment: Array<string> = this.router.url.split('/');

    const level1 = routeSegment[1] ? routeSegment[1].toLowerCase() : null;
    const level2 = routeSegment[2] ? routeSegment[2].toLowerCase() : null;
    const level3 = routeSegment[3] ? routeSegment[3].toLowerCase() : null;
    const level4 = routeSegment[4] ? routeSegment[4].toLowerCase() : null;
    const level5 = routeSegment[5] ? routeSegment[5].toLowerCase() : null;

    let urlCollectionId: number = null;

    if (this.collectionData && this.collectionData.length) {
      if (level1 === RouteSegments.Collections && routeSegment.length > 2) {
        urlCollectionId = this.collectionData.find((d: any) => d.collectionuuId == level2)?.collectionid;
        if (!urlCollectionId) {
          this.userService.logout();
          return;
        }
      }

      let userRole: Array<any> = null;
      if (urlCollectionId && urlCollectionId.toString() != this.currentCollectionId) {
        userRole = await this.getUserRoleByCollectionId(urlCollectionId);
      } else {
        userRole = JSON.parse(JSON.stringify(this.userRoles));
      }

      // Check for access based on route
      if (userRole && userRole.length) {
        // collections routes
        if (level1 === RouteSegments.Collections && routeSegment.length > 3) {
          switch (level3) {
            case RouteSegments.Tests:
              if (!userRole.find(d => d.featureName == 'Tests')) {
                this.userService.logout();
                return;
              }
              break;
            case RouteSegments.Tags:
              let tagAccess = userRole.find(d => d.featureName == AppFeatures.Tags);
              if (tagAccess) {
                if (level5 && !(tagAccess.insertAllowed && tagAccess.updateAllowed && tagAccess.deleteAllowed)) {
                  this.userService.logout();
                  return;
                }
              } else {
                this.userService.logout();
                return;
              }
              break;
            case RouteSegments.Items:
              if (userRole.find(d => d.featureName == AppFeatures.Items)) {
                if (level4) {
                  let userAccess = userRole.find(d => d.featureName == AppFeatures.Items);
                  if (!(userAccess.insertAllowed && userAccess.updateAllowed && userAccess.deleteAllowed)) {
                    this.userService.logout();
                    return;
                  }
                }
              } else {
                this.userService.logout();
                return;
              }
              break;
            case RouteSegments.Reports:
              if (!userRole.find(d => d.featureName == AppFeatures.Reports)) {
                this.userService.logout();
                return;
              }
              break;

            default:
              break;
          }
        }

        // Examinees routes
        else if (level1 === RouteSegments.Examinees) {
          const examinees = userRole.find(d => d.featureName == AppFeatures.Examinees);
          if(examinees) {
            if (routeSegment.length > 2 && !(examinees.insertAllowed && examinees.updateAllowed && examinees.deleteAllowed)) {
              this.userService.logout();
            }
          } else {
            this.userService.logout();
          }
        } else if (level1 === RouteSegments.ExamineeGroup) {
          const examinees = userRole.find(d => d.featureName == AppFeatures.Examinees);
          if(examinees) {
            if (routeSegment.length > 3 && !(examinees.insertAllowed && examinees.updateAllowed && examinees.deleteAllowed)) {
              this.userService.logout();
            }
          } else {
            this.userService.logout();
          }
        }

        // Users routes
        else if (level1 === RouteSegments.Users) {
          if (!userRole.find(d => d.featureName == AppFeatures.Users)) {
            this.userService.logout();
          }
        }

        // Role routes
        else if (level1 == RouteSegments.Roles) {
          if (!userRole.find(d => d.featureName == AppFeatures.Roles)) {
            this.userService.logout();
          }
        } else if (level1 == RouteSegments.AssignPrivileges) {
          const roles = userRole.find(d => d.featureName == AppFeatures.Roles);
          if (!(roles.insertAllowed && roles.updateAllowed && roles.deleteAllowed)) {
            this.userService.logout();
          }
        }
      }
    }

  }

}

export class SelectedUserRole {
  rolesAssigned: string
  collectionId?: number;
  featureName: string;
  updateAllowed: boolean;
  insertAllowed: boolean;
  deleteAllowed: boolean;
  viewAllowed: boolean;
  tagAccessData: any;
}

export class SelectedTagsRole {
  rolesAssigned: string
  collectionId?: number;
  featureName: string;
  updateAllowed: boolean;
  insertAllowed: boolean;
  deleteAllowed: boolean;
  viewAllowed: boolean;
}

export class NavigationRole {
  Items: boolean;
  Roles: boolean;
  Tags: boolean;
  Tests: boolean;
  Users: boolean;
  Reports: boolean;
  Examinees: boolean;
  Collections: boolean;
  RoleDisabled: boolean; // Enable disable complete feature
}

export enum RouteSegments {
  Tags = 'tags',
  Roles = 'roles',
  Tests = 'tests',
  Items = 'items',
  Users = 'users',
  Reports = 'reports',
  Examinees = 'examinees',
  Collections = 'collections',
  ExamineeGroup = 'examinee-group',
  AssignPrivileges = 'assign-privileges'
}

export enum AppFeatures {
  Tags = 'Tags',
  Tests = 'Tests',
  Items = 'Items',
  Roles = 'Roles',
  Users = 'Users',
  Reports = 'Reports',
  Examinees = 'Examinees'
}
